// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Loom = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Loom = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Loom = _exports.Loom = function Loom(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14251)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.1214 8.833L13.9129 8.95339H14.1537H19.9363V11.0491H14.1531H13.9123L14.1209 11.1695L19.1294 14.0609L18.0815 15.8763L13.0725 12.9843L12.864 12.8639L12.9843 13.0725L15.8762 18.0816L14.0609 19.1294L11.1696 14.1209L11.0492 13.9123V14.1531V19.9365H8.95356V14.1526V13.9118L8.83317 14.1203L5.9413 19.1294L4.12601 18.0816L7.01787 13.073L7.13826 12.8645L6.92975 12.9848L1.92128 15.8763L0.873425 14.0609L5.88191 11.169L6.09041 11.0486H5.84965H0.0664692V8.95283H5.85021H6.09099L5.88247 8.83244L0.873434 5.94049L1.92127 4.1257L6.93031 7.0171L7.13881 7.13745L7.01843 6.92897L4.12657 1.92034L5.94131 0.872478L8.83373 5.88165L8.95411 6.09014V5.84939V0.0654927H11.0498V5.84883V6.08964L11.1702 5.88109L14.0615 0.872487L15.8768 1.9209L12.9855 6.92953L12.8651 7.13803L13.0736 7.01766L18.0827 4.12571L19.1304 5.94104L14.1214 8.833ZM6.90028 9.98951C6.90028 11.7027 8.28884 13.0912 10.002 13.0912C11.7151 13.0912 13.1036 11.7027 13.1036 9.98951C13.1036 8.27635 11.7151 6.88775 10.002 6.88775C8.28884 6.88775 6.90028 8.27635 6.90028 9.98951Z",
      fill: "#625DF5",
      stroke: "#212B36",
      "stroke-width": "0.129032"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14251"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }))));
  };
});
